import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { lastValueFrom } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { AbstractRtpRespondentReconService } from '../abstraction/abstract.respondent-reconcilation.service';
import { IRespondentReconTransactions } from '../../interfaces/reconciliation/respondent/respondent-recon-transaction.interface';

@Injectable({
  providedIn: 'root',
})
export class MockRtpRespondentReconService extends AbstractRtpRespondentReconService {
  private tableFilterJson = 'assets/mocks/rtp/reconciliation-respondent/tableFilter.json';
  private reconTransactionsJson =
    'assets/mocks/rtp/reconciliation-respondent/getReconTransactionsByCycle.json';

  constructor(private http: HttpClient) {
    super();
  }

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }
  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    throw new Error('Method not implemented.');
  }

  override getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRespondentReconTransactions[] | undefined> {
    return lastValueFrom(
      this.http.get<IRespondentReconTransactions[]>(this.reconTransactionsJson).pipe(
        tap(transactions => console.log('Fetched Transactions:', transactions)), // Debugging
        map(transactions => {
          return transactions.filter(transaction => {
            console.log(
              `Checking reconWindowId: ${transaction.reconWindowId} === ${reconWindowId}`
            );
            return Number(transaction.reconWindowId) === Number(reconWindowId);
          });
        }),
        tap(filteredTransactions => console.log('Filtered Transactions:', filteredTransactions)) // Debugging
      )
    );
  }
}
